// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"CleanKindList--next-sr-only--4j-h1Z5","tableTitle":"CleanKindList--tableTitle--1EOtAwq"};